import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f35cf5c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-12px" }
const _hoisted_2 = { style: {"white-space":"pre-wrap"} }

import { t } from '@/plugins/i18n'
import { ElMessage, ElMessageBox } from 'element-plus'
import { computed } from 'vue'
import { request } from '@/config/request/interceptors'
import { useClientData } from '@/util/useClientData'
import { useRoute, useRouter } from 'vue-router'
import { useSite, useUser } from '@/store'


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const { data, run } = useClientData(async () => {
  const { data } = await request.customer.customer.shopGetShopNumLimit()
  const { limitShopNum = 0, currentShopNum = 0 } = data ?? {}
  return { maxCount: limitShopNum, count: Math.max(0, limitShopNum - currentShopNum) }
}, { maxCount: 0, count: 0 })

const count = computed(() => data.value.count)

const maxCount = computed(() => data.value.maxCount)

const route = useRoute()

const router = useRouter()

const user = useUser()

expose({
  valid: async () => {
    await run()
    if (count.value === 0) {
      ElMessageBox.confirm(t('您的会员仓位可创建的店铺个数上限为{x}个(2b+2c)', { x: maxCount.value.toString() }), t('提示'), {
        confirmButtonText: t('去升级'),
        cancelButtonText: t('我知道了'),
        type: 'warning'
      })
        .then(() => {
          if (route.path.includes('/vip/VipLevel')) return location.reload()
          router.push(`/${useSite()}/vip/VipLevel`)
        })
        .catch(() => { })
    }
    return true
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createBlock(_component_el_popover, {
    trigger: "hover",
    placement: "top",
    width: 500
  }, {
    reference: _withCtx(() => [
      _createElementVNode("div", _normalizeProps(_guardReactiveProps(_ctx.$attrs)), _toDisplayString(_unref(t)('剩余可新增子店铺数量：X个').replace('X', _unref(count))) + ": ", 17)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('您的会员仓位可创建的店铺个数上限为{x}个(2b+2c)', { x: _unref(maxCount).toString() })), 1)
      ])
    ]),
    _: 1
  }))
}
}

})